<template>
  <vs-popup
    class="popup overflow-hidden"
    button-close-hidden
    v-bind="$attrs"
    v-on="$listeners"
    ref="parentPopUp"
  >
    <img
      class="vs-popup--close-button"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="$emit('close')"
    >
    <div class="w-full mb-8 text-xl font-semibold">
      {{ isView ? 'View' : !id ? 'Add' : 'Edit' }} Quarterly Inspection
    </div>
    <div
      class="p-1 overflow-auto"
    >
      <vs-row
        vs-w="12"
      >
        <vs-col
          vs-w="12"
          class="mb-3 flex flex-col font-semibold text-base"
          style="color: #6546C3"
        >
          General Information
        </vs-col>
        <vs-col
          vs-w="6"
          class="pr-5 mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Inspection Date</span>
          <date-picker
            type="date"
            format="DD-MMM-YYYY"
            value-type="YYYY-MM-DD"
            placeholder="Select Inspection Date"
            v-model="form.inspection_date"
            :is-valid="!!form.inspection_date"
            :disabled="isView || isBusy"
          />
        </vs-col>
        <vs-col
          vs-w="6"
          class="flex flex-col"
        >
          <span class="mb-3 font-semibold">Tug & Barge Owner</span>
          <select-with-search
            :is-busy="isBusy"
            v-model="form.owner_id"
            placeholder="Select Tug & Barge Owner"
            :options="ownerOptions"
            :is-valid="!!form.owner_id"
            @input="handleOwnerChange"
            :disabled="isView || isBusy"
          />
          <span
            v-if="!form.owner_id"
            class="text-danger absolute-bottom-5 left-0"
            style="font-size: .65rem"
          >*Required</span>
        </vs-col>
        <vs-col
          vs-w="6"
          class="pr-5 mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Tug Name</span>
          <select-with-search
            v-model="form.tug_id"
            placeholder="Select Tug Name"
            :options="tugOptions"
            :is-valid="!!form.tug_id"
            :is-busy="isBusy"
            :disabled="isView || isBusy"
          />
          <span
            v-if="!form.tug_id"
            class="text-danger absolute-bottom-5 left-0"
            style="font-size: .65rem"
          >*Required</span>
        </vs-col>
        <vs-col
          vs-w="6"
          class="flex flex-col"
        >
          <span class="mb-3 font-semibold">Barge Name</span>
          <select-with-search
            v-model="form.barge_id"
            placeholder="Select Barge Name"
            :options="bargeOptions"
            :is-valid="!!form.barge_id"
            :is-busy="isBusy"
            :disabled="isView || isBusy"
          />
          <span
            v-if="!form.barge_id"
            class="text-danger absolute-bottom-5 left-0"
            style="font-size: .65rem"
          >*Required</span>
        </vs-col>
        <vs-col
          vs-w="6"
          class="pr-5 mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Status (On Hire)</span>
          <select-with-search
            v-model="form.status_on_hire"
            placeholder="Select Status"
            :options="statuses"
            :is-valid="!!form.status_on_hire"
            :disabled="isView || isBusy"
            :is-busy="isBusy"
          />
          <span
            v-if="!form.status_on_hire"
            class="text-danger absolute-bottom-5 left-0"
            style="font-size: .65rem"
          >*Required</span>
        </vs-col>
        <vs-col
          vs-w="6"
          class="flex flex-col"
        >
          <span class="mb-3 font-semibold">Improvement</span>
          <vs-input
            v-model="form.improvement"
            class="min-w-full"
            placeholder="Enter Improvement"
            :disabled="isView || isBusy"
          />
        </vs-col>
        <vs-col
          vs-w="6"
          class="pr-5 mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Finish (Date)</span>
          <date-picker
            type="date"
            format="DD-MMM-YYYY"
            value-type="YYYY-MM-DD"
            placeholder="Select Finish Date"
            v-model="form.finish_date"
            :disabled="isView || isBusy"
          />
        </vs-col>
        <vs-col
          vs-w="6"
          class="flex flex-col"
        >
          <span class="mb-3 font-semibold">Time Progress (Plan)</span>
          <date-picker
            type="time"
            format="HH:mm:ss"
            value-type="format"
            placeholder="Select Time Progress"
            v-model="form.time_progress_plan"
            :disabled="isView || isBusy"
          />
        </vs-col>
        <vs-col
          vs-w="6"
          class="pr-5 mb-5 flex flex-col"
        >
          <span class="mb-3 font-semibold">Anchor</span>
          <vs-switch
            v-model="form.anchor"
            color="secondary"
            :disabled="isView || isBusy"
          />
        </vs-col>
      </vs-row>
      <vs-row
        v-for="(v, i) in items"
        vs-w="12"
        :key="i"
      >
        <vs-col
          vs-w="12"
          class="mb-3 flex flex-col font-semibold text-base"
          style="color: #6546C3"
        >
          {{ v }}
        </vs-col>
        <vs-col
          vs-w="6"
          class="pr-5 mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Points</span>
          <vs-input
            class="min-w-full"
            v-model="rating_points[i]"
            @input="validateValue(i)"
            @keydown="preventNonNumberDecimal"
            :disabled="isView || isBusy"
            :danger="!isNumber(rating_points[i])"
            :danger-text="'* Required'"
          />
        </vs-col>
        <vs-col
          vs-w="6"
          class="flex flex-col"
        >
          <span class="mb-3 font-semibold">Ratings</span>
          <star-rating
            class="py-2"
            v-model="rating_stars[i]"
            border-color="#d8d8d8"
            :show-rating="false"
            :increment="0.1"
            :border-width="4"
            :rounded-corners="true"
            :star-size="28"
            :read-only="isView || isBusy"
            @rating-selected="val => setRating(val, i)"
          />
        </vs-col>
        <vs-col
          vs-w="12"
          class="mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Picture of Condition</span>
          <input
            type="file"
            id="fileInput"
            :ref="'fileInput_' + i"
            class="hidden"
            accept="image/*"
            @change="onFileChange($event, i)"
            multiple
          >
          <vs-button
            class="flex w-100 text-gray-500 p-3 items-center"
            type="button"
            @click="triggerFileInput(i)"
            style="background-color: #F1F1FD"
            :disabled="isView || isBusy"
          >
            <div class="flex flex-row items-center justify-start pr-2 w-full">
              <img
                :src="require('@/assets/shipo-icon-edit-upload.svg')"
                class="flex-shrink-0 mr-2 h-6"
              >
              <div class="truncate">
                Select image(s) to upload
              </div>
            </div>
          </vs-button>
          <span
            v-if="attachments[i].length === 0"
            class="text-danger absolute-bottom-5 left-0"
            style="font-size: .65rem"
          >*Required</span>

          <div
            v-if="attachments[i].length"
            class="w-100 gap-3"
          >
            <div
              v-for="(img, index) in attachments[i]"
              :key="index"
              :class="`image-container ${isView ? 'cursor-pointer' : ''}`"
              @click="isView ? $emit('open-preview', attachments[i]) : ''"
            >
              <img
                :src="img.dataUrl"
                alt="Preview"
                class="image-preview"
              >
              <vs-icon
                v-if="!isView && !isBusy"
                class="remove-button cursor-pointer"
                icon="close"
                color="#EE443F"
                size="small"
                @click="removeImage(index, i)"
              />
            </div>
          </div>
        </vs-col>
        <vs-col
          vs-w="12"
          class="mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Remark</span>
          <vs-textarea
            v-model="remark[i]"
            :disabled="isView || isBusy"
          />
        </vs-col>
      </vs-row>
      <vs-row
        vs-w="12"
      >
        <vs-col
          vs-w="12"
          class="mb-3 flex flex-col font-semibold text-base"
          style="color: #6546C3"
        >
          RESULT / CONCLUSION
        </vs-col>
        <vs-col
          vs-w="6"
          class="mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Total Points</span>
          <span class="text-red-600 text-3xl font-semibold">{{ totalPoints }}</span>
        </vs-col>
        <vs-col
          vs-w="6"
          class="flex flex-col"
        >
          <span class="mb-3 font-semibold" />
          <div class="flex flex-row gap-3">
            <vs-button
              type="filled"
              :class="`w-full shadow-none ${categoryScore === 'poor' ? 'avg-active danger' : 'avg-inactive'}`"
            >
              Poor
            </vs-button>
            <vs-button
              type="filled"
              :class="`w-full shadow-none ${categoryScore === 'fair' ? 'avg-active warning' : 'avg-inactive'}`"
            >
              Fair
            </vs-button>
            <vs-button
              type="filled"
              :class="`w-full shadow-none ${categoryScore === 'good' ? 'avg-active success' : 'avg-inactive'}`"
            >
              Good
            </vs-button>
          </div>
        </vs-col>
        <vs-col
          vs-w="12"
          class="mb-3 flex flex-col"
        >
          <span class="mb-3 font-semibold">Conclusion Remark</span>
          <vs-textarea
            v-model="form.conclusion_remark"
            :disabled="isView || isBusy"
          />
        </vs-col>
      </vs-row>
    </div>
    <div class="mt-5 flex w-full gap-5">
      <vs-button
        v-if="!isView"
        type="border"
        color="primary"
        class="w-full h-12"
        @click="$emit('close')"
      >
        Cancel
      </vs-button>
      <div class="w-full flex flex-col gap-2">
        <vs-button
          type="filled"
          color="primary"
          class="w-full h-12"
          @click="isView ? $emit('handle-download') : onHandleSubmit()"
          :disabled="isBusy"
        >
          {{ isView ? 'Export Data' : `${isAdding ? 'Create' : 'Save'} Quarterly Inspection` }}
        </vs-button>
        <vs-progress
          indeterminate
          v-show="isSubmitting"
          color="primary"
        />
      </div>
    </div>
  </vs-popup>
</template>

<script>
import moment from 'moment'
import StarRating from 'vue-star-rating'

import DatePicker from '@/components/datePicker'
import SelectWithSearch from '@/components/selectWithSearch'

export default {
  components: {
    DatePicker,
    SelectWithSearch,
    StarRating
  },
  props: {
    isView: {
      type: Boolean,
      default: () => false
    },
    isAdding: {
      type: Boolean,
      default: () => true
    },
    id: {
      type: String,
      default: () => ''
    },
    ownerOptions: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isBusy: false,
    form: {
      inspection_date: moment().format('YYYY-MM-DD'),
      owner_id: null,
      tug_id: null,
      barge_id: null,
      status_on_hire: null,
      improvement: null,
      time_progress_plan: null,
      finish_date: null,
      anchor: true,
      conclusion_remark: null
    },
    statuses: [],
    items: [],
    rating_points: [],
    rating_stars: [],
    attachments: [],
    remark: [],
    categoryScore: 'poor',
    tugOptions: [],
    bargeOptions: [],
    totalPoints: 0,
    isSubmitting: false
  }),
  computed: {},
  watch: {
    rating_points: {
      immediate: true,
      handler(val) {
        if (val) {
          this.totalPoints = 0
          const temp = this.cloneDeep(val)
          this.rating_stars = temp.map(v => Number(v))

          this.calculateTotalPoints(val)
        }
      }
    },
    totalPoints: {
      immediate: true,
      handler(val) {
        if (val) {
          this.calculateCategory(val)
        }
      }
    }
  },
  mounted() {
    this.fetchStatusQuarterlyInspection()
    this.fetchItemsQuarterlyInspection()
    if (this.id) {
      this.fetchDetail()
    }
  },
  methods: {
    async fetchDetail() {
      this.isBusy = true
      const detail = await this.$store.dispatch('QuarterlyInspection/fetchQuarterlyInspectionDetail', this.id);

      this.form = {
        inspection_date: detail.inspection_date,
        owner_id: detail.owner_id,
        status_on_hire: detail.status_on_hire,
        improvement: detail.improvement,
        time_progress_plan: detail.time_progress_plan,
        finish_date: detail.finish_date,
        anchor: detail.anchor,
        conclusion_remark: detail.conclusion_remark
      }

      await this.fetchTugOptions()
      await this.fetchBargeOptions()

      detail.details.map((v, i) => {
        const idx = this.items.findIndex(k => k === v.inspection_item_name)
        if (idx > -1) {
          this.rating_points[idx] = v.rating_points
          this.attachments[idx] = v.attachments.map(f => ({
            file: f,
            dataUrl: f.thumbnail
          }))
          this.remark[idx] = v.remark
        }
      })

      this.rating_stars = this.rating_points

      this.calculateTotalPoints(this.rating_points)
      this.calculateCategory(this.totalPoints)

      this.form.tug_id = detail.tug_id
      this.form.barge_id = detail.barge_id
      this.isBusy = false
    },
    calculateTotalPoints(data) {
      const sum = data.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue) ?? 0, 0);
      if (sum < 0) {
        this.totalPoints = 0
        return
      }
      const avgPoint = sum / this.items.length

      this.totalPoints = Number(avgPoint).toFixed(2)
    },
    calculateCategory(data) {
      if (data >= 3.51 && data <= 5) {
        this.categoryScore = 'good'
      }
      if (data <= 2.5) {
        this.categoryScore = 'poor'
      }
      if (data >= 2.51 && data <= 3.5) {
        this.categoryScore = 'fair'
      }
    },
    isNumber(value) {
      if (this.isView) {
        return true
      }
      return typeof value === 'number' || (!isNaN(value) && value !== '' && value !== null);
    },
    async handleOwnerChange() {
      this.form.tug_id = null;
      this.form.barge_id = null;

      this.tugOptions = [];
      this.bargeOptions = [];

      if (!this.form.owner_id) {
        return;
      }

      this.fetchTugOptions()
      this.fetchBargeOptions()
    },
    async fetchTugOptions() {
      try {
        const tugResponse = await this.$store.dispatch('TugBargesCombination/fetchTugBargesDropdown', {
          data: 'tugs',
          owner_name: this.ownerOptions.find(v => v.value === this.form.owner_id).text
        });
        if (!tugResponse.error) {
          this.tugOptions = tugResponse.map(v => ({ text: v.name, value: v.id }))
          const unique = this.tugOptions.filter((item, index, self) =>
            index === self.findIndex(obj => obj.value === item.value)
          );
          this.tugOptions = unique
        }
      } catch ({ error }) {
        this.showFailedNotification(this, error?.message || 'Request failed (CORS or network issue).');
        this.tugOptions = [];
      }
    },
    async fetchBargeOptions() {
      try {
        const bargeResponse = await this.$store.dispatch('TugBargesCombination/fetchTugBargesDropdown', {
          data: 'barges',
          owner_name: this.ownerOptions.find(v => v.value === this.form.owner_id).text
        });
        if (!bargeResponse.error) {
          this.bargeOptions = bargeResponse.map(v => ({ text: v.name, value: v.id }))
          const unique = this.bargeOptions.filter((item, index, self) =>
            index === self.findIndex(obj => obj.value === item.value)
          );
          this.bargeOptions = unique
        }
      } catch ({ error }) {
        this.showFailedNotification(this, error?.message || 'Request failed (CORS or network issue).');
        this.bargeOptions = [];
      }
    },
    triggerFileInput(index) {
      this.$refs[`fileInput_${index}`]?.[0]?.click()
    },
    onFileChange(event, index) {
      const files = Array.from(event.target.files);

      files.forEach(file => {
        if (file.type.startsWith("image/")) {
          const reader = new FileReader()

          // Create a new file name with timestamp
          const timestamp = this.moment().format('YYYY-MM-DD_HH-mm-ss-SSS')
          const extension = file.name.split('.').pop()
          const baseName = file.name.replace(/\.[^/.]+$/, "") // remove extension
          const newName = `${baseName}_${timestamp}.${extension}`

          // Create a new File object
          const renamedFile = new File([file], newName, {
            type: file.type,
            lastModified: file.lastModified
          })

          reader.onload = e => {
            const tempFiles = this.attachments[index]
            tempFiles.push({
              file: renamedFile,
              dataUrl: e.target.result
            })
            this.$set(this.attachments, index, tempFiles);
          }

          reader.readAsDataURL(renamedFile)
        }
      });

      event.target.value = null
    },
    removeImage(index, i) {
      const updatedFiles = [...this.attachments[i]]
      updatedFiles.splice(index, 1)
      this.$set(this.attachments, i, updatedFiles)
    },
    validateValue(i) {
      let val = this.cloneDeep(this.rating_points[i])
      if (val.startsWith('.')) {
        this.$set(this.rating_points, i, 0);
        return
      }

      if (val < 0) val = 0
      if (val > 5) val = 5
      this.$set(this.rating_points, i, val);
    },
    setRating(val, i) {
      this.$set(this.rating_points, i, val);
    },
    async fetchStatusQuarterlyInspection() {
      const { data } = await this.$store.dispatch('QuarterlyInspection/getQuarterlyInspectionStatus')
      if (data) {
        this.statuses = data.map(v => ({ text: v, value: v}))
      } else {
        this.statuses = []
      }
        
    },
    async fetchItemsQuarterlyInspection() {
      const { data } = await this.$store.dispatch('QuarterlyInspection/getQuarterlyInspectionItems')
      if (data) {
        this.items = data

        data.map(v => {
          this.attachments.push([])
          this.rating_points.push(null)
          this.rating_stars.push(null)
          this.remark.push('')
        })
      } else {
        this.items = []
      }
    },
    async onHandleSubmit() {
      try {
        this.isBusy = true
        this.isSubmitting = true
        const notRequired = [
          'improvement',
          'time_progress_plan',
          'finish_date',
          'conclusion_remark'
        ]
        const validate = Object.keys(this.form)
          .find(key => !notRequired.includes(key) && (this.form[key] === '' || this.form[key] === null))
        if (validate) {
          this.showFailedNotification(this, `${validate.replaceAll('_', ' ').replace('id', '')} cannot be empty`, 'Error')
          this.isBusy = false
          this.isSubmitting = false
          return
        }

        const validateRatingPoint = this.rating_points.findIndex(v => !this.isNumber(v))
        if (validateRatingPoint > -1) {
          this.showFailedNotification(this, `${this.items[validateRatingPoint]} Rating Point cannot be empty`, 'Error')
          this.isBusy = false
          this.isSubmitting = false
          return
        }

        const validateAttachment = this.attachments.findIndex(v => this.isEmpty(v))
        if (validateAttachment > -1) {
          this.showFailedNotification(this, `${this.items[validateAttachment]} Attachment cannot be empty`, 'Error')
          this.isBusy = false
          this.isSubmitting = false
          return
        }

        const formData = new FormData()
        formData.append('inspection_date', this.form.inspection_date)
        formData.append('owner_id', this.form.owner_id)
        formData.append('tug_id', this.form.tug_id)
        formData.append('barge_id', this.form.barge_id)
        formData.append('status_on_hire', this.form.status_on_hire)
        formData.append('anchor', this.form.anchor)

        if (!this.isEmpty(this.form.improvement)) {
          formData.append('improvement', this.form.improvement)
        }
        if (!this.isEmpty(this.form.time_progress_plan)) {
          formData.append('time_progress_plan', this.form.time_progress_plan)
        }
        if (!this.isEmpty(this.form.finish_date)) {
          formData.append('finish_date', this.form.finish_date)
        }
        if (!this.isEmpty(this.form.conclusion_remark)) {
          formData.append('conclusion_remark', this.form.conclusion_remark)
        }

        const formDetails = []

        // populate details
        this.items.map((v, i) => {
          formDetails.push({
            "inspection_item_name": v,
            "rating_points": this.rating_points[i],
            "remark": this.remark[i] ?? '',
            "attachments": this.attachments[i].map(k => {
              if (k.file.fileId) {
                return {
                  ...k.file
                }
              }
              return { fileName: k.file.name }
            })
          })
        })
        formData.append('details', JSON.stringify(formDetails))

        // populate files
        const tempFiles = this.attachments.map(v => v.map(k => {
          if (!k.file.fileId) {
            return k.file
          }
          return null
        }))
        tempFiles.flat().map(v => {
          if (v)
            formData.append('files', v)
        })

        if (this.isAdding) {
          await this.$store.dispatch('QuarterlyInspection/postQuarterlyInspection', formData)
        } else {
          const tempForm = {
            id: this.id,
            form: formData
          }
          await this.$store.dispatch('QuarterlyInspection/putQuarterlyInspection', tempForm)
        }

        this.$emit('close')

        this.showSuccessNotification(this, `Quarterly Inspection successfully ${this.isAdding ? 'created' : 'updated'}.`)
        this.isBusy = false
        this.isSubmitting = false
      } catch ({ error }) {
        this.isBusy = false
        this.isSubmitting = false
        const message = error?.errors?.[0]?.[0]?.message || error?.message || 'Request failed (CORS or network issue).'

        this.showFailedNotification(this, message, 'Error')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-container {
  display: inline-block;
  margin: 10px;
  position: relative;
}
.image-preview {
  max-width: 150px;
  max-height: 150px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.remove-button {
  position: absolute;
  top: -8px;
  right: -8px;
  border: none;
  font-size: 18px;
  border-radius: 4px;
}
.popup {
  /deep/.vs-popup {
    // @apply w-full;
    @apply rounded-2xl;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply p-6;
      @apply relative;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;
      @apply overflow-hidden;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 35px;
      top: 1rem;
      right: 1rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply border-2;
      @apply mt-20;
      @apply py-4;
      @apply min-w-button;
      @apply font-semibold;
      height: calc( 1rem * 10 / 3 );

      &.shadow-secondary {
        -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
        box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      }

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
.container-file {
  display: flex;
  background-color: #D1F9E3;
  color: #15AF59;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  border-radius: 5px;
  

  &.empty {
    background-color: #ECEBED;
    color: #818181;
  }
}
.avg-active {
  color: #FFF;
  background: #15AF59 !important;

  &.warning {
    background: #FFAA00 !important;
  }

  &.danger {
    background: #EE443F !important;
  }
}
.avg-inactive {
  color: #818181;
  background: #DADADA !important;
}
</style>
